export default "__VITE_ASSET__Cvwb$Bg3__"